module.exports = __webpack_public_path__ + "video-btn-417b2428.png";